import React from 'react';
import { Modal, ModalBody, Button } from 'reactstrap';

export default function SaleSupportDelete(props) {
    return (
        <Modal isOpen={props.isOpen} toggle={props.hide}>
            <ModalBody>
                <p>
                    ¿Estás seguro que deseas eliminar el material de apoyo <em>{props.item ? props.item.title : null}</em>?
                </p>
                <p className="text-danger">
                    Esta acción NO puede deshacerse
                </p>
                {
                    props.deleting ?
                        <div className="text-right">
                            <i className="fa fa-spinner fa-spin"></i> Eliminando...
                        </div>
                    :
                        <div className="text-right">
                            <Button color="secondary" size="sm" className="mr-1" onClick={props.hide}>Cancelar</Button>
                            <Button color="danger" size="sm" onClick={() => props.deleteItem(props.item)}>Sí, eliminar</Button>
                        </div>
                }
            </ModalBody>
        </Modal>
    );
}


/** WEBPACK FOOTER **
 ** ./src/components/presentation/support/SaleSupportDelete.jsx
 **/